// extracted by mini-css-extract-plugin
module.exports = {"statusRow":"AiBot_statusRow__1haLW","switch":"AiBot_switch__2NWIr","slider":"AiBot_slider__2CHmo","statusLabel":"AiBot_statusLabel__3lJCB"};